<template>
  <navbar
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template
      v-if="isSameAthlete || isApplicableClubStaff"
      v-slot:side-menu="menuProps"
    >
      <athlete-side-menu
        v-if="isSameAthlete"
        v-bind="menuProps"
      />
      <club-side-menu
        v-if="isApplicableClubStaff"
        v-bind="menuProps"
      />
    </template>

    <template v-slot:identifier>
      <div class="flex items-center ml-2">
        <athlete-identifier />
      </div>
    </template>

    <template v-slot:actions>
      <slot name="actions" />
    </template>

    <template v-slot:overlay>
      <transition name="fade-out">
        <success-overlay
          v-if="showFeedbackSuccess"
          text="Request has been sent!"
        />
        <success-overlay
          v-else-if="showFavoriteSuccess"
          text="Athlete favorited"
        />
        <success-overlay
          v-else-if="showSkipSuccess"
          text="Athlete skipped"
        />
      </transition>
    </template>
  </navbar>
</template>

<script>
import Navbar from '@/components/Navbar'
import AthleteSideMenu from '@/components/SideMenus/AthleteProfile/Athlete'
import ClubSideMenu from '@/components/SideMenus/AthleteProfile/Club'
import AthleteIdentifier from './AthleteIdentifier'
import SuccessOverlay from './SuccessOverlay'
import { mapGetters } from 'vuex'

export default {
    components: {
        Navbar,
        AthleteSideMenu,
        ClubSideMenu,
        AthleteIdentifier,
        SuccessOverlay,
    },

    data() {
        return {
            showFeedbackSuccess: false,
            showFavoriteSuccess: false,
            showSkipSuccess: false,
            successTimeout: 3000,
        }
    },

    computed: {
        ...mapGetters('athleteProfile', [
            'isSameAthlete',
            'isApplicableClubStaff',
            'isSendingFeedbackRequest',
            'isFavorited',
            'isSkipped',
        ]),

        canNavigateBack() {
            return this.cameFromOurSite
        },

        cameFromOurSite() {
            // https://stackoverflow.com/a/19417148
            const referrerDomain = document.referrer.split('/')[2]
            return referrerDomain === location.host
        },
    },

    watch: {
        isSendingFeedbackRequest(is) {
            if (is) {
                this.showFeedbackSuccess = true
            }
        },

        isFavorited(is) {
            if(!this.showFavoriteSuccess) {
                this.showFavoriteSuccess = is
            }
        },

        isSkipped(is) {
            if(!this.showSkipSuccess) {
                this.showSkipSuccess = is
            }
        },

        showFeedbackSuccess(show) {
            show && setTimeout(() => this.showFeedbackSuccess = false, this.successTimeout)
        },

        showFavoriteSuccess(show) {
            show && setTimeout(() => this.showFavoriteSuccess = false, this.successTimeout)
        },

        showSkipSuccess(show) {
            show && setTimeout(() => this.showSkipSuccess = false, this.successTimeout)
        },
    },
}
</script>

<style lang="scss">
.fade-out-enter-active {
    //
}

.fade-out-leave-active {
    transition: opacity 0.5s;
}

.fade-out-enter {
    //
}

.fade-out-leave-to {
    opacity: 0;
}
</style>